export default {
  siteName: '宅宅资源库',
  heroTitle: '宅宅资源库',
  heroSubtitle: '专为二次元爱好者打造的资源聚合平台，涵盖动漫、漫画、游戏、轻小说等海量宅系资源，一站式满足你的宅文化需求。',
  exploreBtn: '立即探索',
  learnMore: '了解更多',
  categoryTitle: '探索资源分类',
  categoryDesc: '六大资源分类，覆盖你的所有宅文化需求',
  hotResources: '热门资源',
  hotResourcesDesc: '社区最受欢迎的资源精选',
  viewAll: '查看全部',
  latestUpdates: '最新更新',
  latestUpdatesDesc: '每日更新，不错过任何精彩内容',
  statsUsers: '注册用户',
  statsResources: '资源总数',
  statsPosts: '社区帖子',
  statsUptime: '可用率',
  faqTitle: '常见问题',
  faqDesc: '关于宅宅资源库，你可能想了解的内容',
  ctaTitle: '加入百万宅友的行列',
  ctaDesc: '海量资源每日更新，社区氛围温暖友好，快来和全球宅友一起交流分享吧！',
  ctaBtn: '关于宅宅资源库',
  footerDesc: '专为二次元爱好者打造的资源聚合平台，涵盖动漫、漫画、游戏、轻小说等海量宅系资源，一站式满足你的宅文化需求。',
  footerCategories: '资源分类',
  footerQuickLinks: '快速链接',
  footerFollow: '关注我们',
  footerEmail: '联系邮箱',
  footerCopyright: '© 2024-2026 宅宅资源库 Zhazhai.moe - 版权所有',
  navHome: '首页',
  navAnime: '动漫',
  navManga: '漫画',
  navGame: '游戏',
  navLightNovel: '轻小说',
  navAbout: '关于我们',
  navJoin: '加入我们',
  breadcrumbHome: '首页',
  aboutTitle: '关于我们',
  missionTitle: '我们的使命',
  visionTitle: '我们的愿景',
  milestonesTitle: '发展历程',
  testimonialsTitle: '宅友口碑',
  contactTitle: '联系我们',
  contactInfo: '联系方式',
  contactMessage: '给我们留言',
};